import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, IconButton, CircularProgress } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { NotificationActions, PointManagementActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px',
    },
    pointRate: {
        textAlign: 'right',
        fontSize: '14px',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const pointManagementSelector = (state) => state.PointManagements;
const IdentitySelector = (state) => state.Identity;

const PointManagementList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const pointManagementActions = bindActionCreators(PointManagementActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, nowWainting } = useSelector(pointManagementSelector);
    const { token, permissions } = useSelector(IdentitySelector);
   
    const { classes } = props;

    // 一覧のフィルタリング要素の復元用
    var merchantName = props.merchantName;  // 加盟店名
    var merchantType = props.merchantType;  // 加盟店タイプ
    var pointName = props.pointName;        // ポイント設定名
    var pointKbn = props.pointKbn;        // ポイント種別
    var applyKbn = props.applyKbn;          // 適用区分

    const listDefinition = {
        columns: [
            {
                // 加盟店名
                title: <FormattedMessage id="Merchant.Name" />,
                field: 'merchant_name',
                filtering: true,
                defaultFilter: props.merchantName,
            },
            {
                // 加盟店タイプ
                title: <FormattedMessage id="Merchant.Type" />,
                field: 'merchant_type',
                lookup: {
                    "acquirer": "代表",
                    "general": "一般",
                },
                filtering: true,
                defaultFilter: props.merchantType,
            },
            {
                // 設定名
                title: <FormattedMessage id="PointManagement.PointName" />,
                field: 'point_name',
                filtering: true,
                defaultFilter: props.pointName,
            },
            {
                // ポイント種別
                //title: <FormattedMessage id="PointManagement.PointKbn" />,
                title: "種別",
                field: 'point_kbn',
                lookup: {
                    "1": "カード",
                    "2": "ＱＲ",
                    //1: <FormattedMessage id="PointManagement.PointKbn.Card" />,
                    //2: <FormattedMessage id="PointManagement.PointKbn.Qr" />,
                },
                filtering: true,
                defaultFilter: props.pointKbn,
            },
            {
                // 期間（開始日と終了日を連結した文字列を表示）
                title: <FormattedMessage id="PointManagement.Period" />,
                field: 'period',
                filtering: false
            },
            {
                // ポイント率
                title: <FormattedMessage id="PointManagement.PointRate" />,
                field: 'point_rate',
                filtering: false,
                render: rowData => {
                    var pointRate = Number(rowData.point_rate).toFixed(1);
                    return (
                        // パーセント表示
                        <Typography className={classes.pointRate} >{pointRate}%</Typography>
                    )
                }
            },
            {
                // 適用区分
                //title: <FormattedMessage id="PointManagement.ApplicableCategory" />,
                title: "適用",
                field: 'apply_kbn',
                filtering: true,
                lookup: {
                    true: "有効",
                    false: "無効",
                },
                defaultFilter: props.applyKbn,
            },
        ]
    };
  
    /**
     *
     * フィルター変更時
     *
     * @param filter フィルターデータ配列
     */
    const onChangeFilter = (filter) => {
        merchantName = '';
        merchantType = '';
        pointName = '';
        pointKbn = '';
        applyKbn = '';

        // フィルタリング内容を退避
        if (filter.length > 0) {
            for (let i = 0; i < filter.length; i++) {
                if (filter[i].column.field == 'merchant_name') {
                    merchantName = filter[i].value;
                } else if (filter[i].column.field == 'merchant_type') {
                    merchantType = filter[i].value;
                } else if (filter[i].column.field == 'point_name') {
                    pointName = filter[i].value;
                } else if (filter[i].column.field == 'point_kbn') {
                    pointKbn = filter[i].value;
                } else if (filter[i].column.field == 'apply_kbn') {
                    applyKbn = filter[i].value;
                }
            };
        }
    }

    /**
     *
     * 初期表示
     * 
     */
    useEffect(() => {
        // 初期レンダリングの時のみポイント設定情報の一覧を取得
        if (props.refresh == null || props.refresh == true) {
            pointManagementActions.listPoints(token)
                .then(data => {
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }
    }, []);

    /**
     * 
     * 詳細ボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onDetailClick = (data) => {
        // 選択された行と復元用に変更されたフィルタリング要素を返却
        props.onDetail(data, merchantName, merchantType, pointName, pointKbn, applyKbn);
    }
   
    /**
     *
     * 設定追加ボタン押下時の処理
     *
     * @param data 選択された行のデータ
     */
    const onAddClick = () => {
        // 復元用に変更されたフィルタリング要素を返却
        props.onCreate(merchantName, merchantType, pointName, pointKbn, applyKbn);
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    // 設定追加ボタンの活性・非活性の制御
    var addButtonDisabled = true;
    if (permissions != null && permissions != undefined && permissions.fid5_5 != null && (permissions.fid5_5.value.value & 2) == 2) {
        // ポイント管理の編集権限の有りの場合のみ設定追加ボタンを活性（fid5_5：ポイント管理）
        addButtonDisabled = false;
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <MaterialTable
                title={<Typography component="h1" variant="inherit">{<FormattedMessage id="PointManagement.SettingsList" />}</Typography>}
                onFilterChange={(filter) => onChangeFilter(filter)}
                columns={listDefinition.columns}
                data={list}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1,
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    // 右端のアクションボタン列（設定追加ボタン、詳細画面遷移ボタン）
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <IconButton aria-label="detail" onClick={() => onDetailClick(actionProps.data)}>
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            )
                        } else {
                            return (
                                <Button onClick={() => onAddClick()} variant="contained" color="secondary" size="medium" startIcon={<AddCircleOutlineIcon />}
                                    disabled={addButtonDisabled}>
                                    <FormattedMessage id="Button.AddSetting" />
                                </Button>
                            )
                        }
                    },
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(PointManagementList);
